import React, { createContext, useContext, useState, ReactNode, FunctionComponent } from 'react';

interface SearchContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

interface SearchProviderProps {
  children: ReactNode;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

const SearchProvider: FunctionComponent<SearchProviderProps> = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  
  return (
    <SearchContext.Provider value={{
      searchQuery,
      setSearchQuery,
    }}>
      {children}
    </SearchContext.Provider>
  );
};

const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchContext måste användas inom en SearchProvider');
  }
  return context;
};

export { useSearchContext, SearchProvider };
